import React from "react";

import { APIPost, APIGet } from "services/APIRequest"

import UrlServer from "configs/UrlServer"
import { ErrorsCallback, SuccessCallback, WarningCallback, QuestionCallback } from "alertService"
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Button from "components/CustomButtons/Button.jsx"
import CustomInput from "components/CustomInput/CustomInput.jsx"
import withStyles from "@material-ui/core/styles/withStyles";

import Autocomplete from "components/Autocomplete/Select.jsx";
import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
var W3CWebSocket = require('websocket').w3cwebsocket;
var client = new W3CWebSocket('ws://127.0.0.1:8748/QAgent');
class PageTestPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      runIndex: 0,
      dealerList: null,
      currentYearList: null,
      yearList: [
        {
          label: "ชุดข้อมูลของ เดือน 7 ปี 2020 ถึง เดือน 6 ปี 2021",
          value: "2020",
        },
        {
          label: "ชุดข้อมูลของ เดือน 7 ปี 2021 ถึง เดือน 6 ปี 2022",
          value: "2021",
        }
      ],

      currentQuarterNumber: null,
      QuarterNumberList: [
        {
          label: "เปิดแสดงข้อมูลของ Quarter ที่ 2",
          value: "2",
        },
        {
          label: "เปิดแสดงข้อมูลของ Quarter ที่ 2 และ 3",
          value: "3",
        },
        {
          label: "เปิดแสดงข้อมูลของ Quarter ที่ 2,3 และ 4",
          value: "4",
        },
        {
          label: "เปิดแสดงข้อมูลของ Quarter ที่ 2,3,4 และ 1",
          value: "1",
        }
      ],
      logs: [],
      isLoading: false,
      isFinish: false
    }
  }
  componentDidMount() {

    APIPost(UrlServer.URL_POST_GET_DEALER, {}, ({ datas }) => {
      this.setState({
        dealerList: datas
      }, () => {
      });
    })
  }

  handleChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };
  handleChangeAutoCompleteNormally = name => value => {
    this.setState({
      [name]: value,
    }, () => {

    })
  }
  onRun = () => {
    if (!this.state.currentYearList) {
      WarningCallback("โปรดเลือกข้อมูลในรอบปีที่ต้องการ");
      return
    }
    if (!this.state.currentQuarterNumber) {
      WarningCallback("โปรดเลือกข้อมูลเปิดแสดง Quarter");
      return
    }
    APIPost("api/generateReports/callCleanRawReportGenerate", {
      y: this.state.currentYearList.value,
      qtn: this.state.currentQuarterNumber.value,
      dc: this.state.dealerList[this.state.runIndex].dealer_code
    }, (datas) => {
      var logs = this.state.logs
      logs.unshift(this.state.dealerList[this.state.runIndex])
      this.setState({
        runIndex: this.state.runIndex + 1,
        logs: logs,
        isFinish: this.state.dealerList.length <= (this.state.runIndex + 1)
      }, () => {
        if (this.state.runIndex < this.state.dealerList.length) {
          this.onRun()
        }
      })
    })
  }
  randerLogs = (logs) => {
    return logs.map((row, index) => {
      return <div>{logs.length - (index)}/{this.state.dealerList.length} ({row.dealer_code}) {row.branch_name} เรียบร้อย</div>
    })
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container + " fullWidth"}>
        <GridContainer >
          <GridItem xs={12} sm={12} md={11}>
            <Card testimonial>

              {
                this.state.isLoading ?
                  <div>
                    <div>
                      <h2>Run Generate Quarter Report Data (จำนวน {this.state.dealerList ? this.state.dealerList.length : 0} สาขา)</h2>
                    </div>
                    {this.state.currentYearList.label + " , " + this.state.currentQuarterNumber.label}
                  </div>
                  :
                  <GridContainer justify="center">
                    <GridItem xs={12}>
                      <div>
                        <h2>Run Generate Quarter Report Data (จำนวน {this.state.dealerList ? this.state.dealerList.length : 0} สาขา)</h2>
                      </div>
                    </GridItem>
                    <GridItem xs={11}>
                      <br />
                      <Autocomplete
                        handleChange={this.handleChangeAutoCompleteNormally}
                        value={this.state.currentYearList}
                        dataList={this.state.yearList}
                        id="currentYearList"
                        label="เลือกข้อมูลในรอบปี"
                      // multi
                      />
                    </GridItem>
                    <GridItem xs={11}>
                      <br />
                      <Autocomplete
                        handleChange={this.handleChangeAutoCompleteNormally}
                        value={this.state.currentQuarterNumber}
                        dataList={this.state.QuarterNumberList}
                        id="currentQuarterNumber"
                        label="เลือกเปิดแสดง Quarter"
                      // multi
                      />
                    </GridItem>
                    <GridItem xs={11}>
                      <br />
                      <Button
                        fullWidth
                        color="info"
                        round
                        onClick={e => {
                          this.setState({
                            runIndex: 0,
                            isLoading: true,
                            logs: []
                          }, () => {
                            this.onRun()
                          })
                        }}
                      >
                        Run Generate
                      </Button>
                    </GridItem>
                  </GridContainer>
              }
              <CardBody>
              </CardBody>
            </Card>
          </GridItem>
          {this.state.isLoading ?
            <GridItem xs={12} sm={12} md={11} className="hr-s text-read">
              {/* <Card testimonial> */}
              <h3>Logs Process</h3>
              {
                this.state.isFinish ? "การทำงานเรียบร้อยสมบรูณ์" : "กำลังทำการประมวลผลข้อมูล.....โปรดรอจนกว่าจะครบทุกสาขา..."
              }

              <br />
              {this.randerLogs(this.state.logs)}
              {/* </Card> */}
              <h3>--------------------</h3>
            </GridItem>
            : ""}
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(loginPageStyle)(PageTestPage);
